import { toLowerCase } from './string';

export function sortCaseIgnore(x, y) {
  return toLowerCase(x).localeCompare(toLowerCase(y));
}

export function getIndexesArray({ length, start = 0 }) {
  function mapIndexes(index) {
    return index + start;
  }

  return Number.isFinite(length)
    ? start
      ? [...Array(length).keys()].map(mapIndexes)
      : [...Array(length).keys()]
    : [];
}
